import * as DataModel from '../model/CaesarCipherModel'

export class CaesarCipherController {
    model = null;

    constructor() {
        this.setupCipher();
    }

    setupCipher() {
        this.model = new DataModel.CaesarCipherModel();

        this.model.alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
        this.model.cipherShift = 1 + Math.floor(Math.random() * 24);
        this.model.scrambledAlphabet = [];
        let index = this.model.cipherShift;
        for (let i = 0; i < 26; i++) {
            if (index >= this.model.alphabet.length) {
                index = 0;
            }
            this.model.scrambledAlphabet.push(this.model.alphabet[index]);
            index++;
        }
        this.model.potentialAnswers = DataModel.CAESAR_WORDS[Math.floor(Math.random() * DataModel.CAESAR_WORDS.length)].split('|');
        this.model.cipherPhrase = this.model.potentialAnswers[0].toUpperCase();
        let phraseSplit = this.model.cipherPhrase.split('');
        let scrambledArray = [];
        for (let i = 0; i < phraseSplit.length; i++) {
            if (this.model.alphabet.indexOf(phraseSplit[i]) >= 0) {
                scrambledArray.push(this.model.scrambledAlphabet[this.model.alphabet.indexOf(phraseSplit[i])]);
            } else {
                scrambledArray.push(phraseSplit[i]);
            }

        }
        this.model.scrambledPhrase = scrambledArray.join('');
        // console.log('Word: ' + this.model.cipherPhrase, 'Shift: ' + this.model.cipherShift, this.model.alphabet, this.model.scrambledAlphabet, this.model.scrambledPhrase);

        this.model.currentTestShift = 0;
    }

    testShiftUp() {
        this.model.currentTestShift++;
        if (this.model.currentTestShift > DataModel.MAX_SHIFT) {
            this.model.currentTestShift = DataModel.MIN_SHIFT;
        }
    }

    testShiftDown() {
        this.model.currentTestShift--;
        if (this.model.currentTestShift < DataModel.MIN_SHIFT) {
            this.model.currentTestShift = DataModel.MAX_SHIFT;
        }
    }

    setShift(newShift) {
        this.model.currentTestShift = newShift;
        if (this.model.currentTestShift > DataModel.MAX_SHIFT) {
            this.model.currentTestShift = DataModel.MIN_SHIFT;
        }
        if (this.model.currentTestShift < DataModel.MIN_SHIFT) {
            this.model.currentTestShift = DataModel.MAX_SHIFT;
        }
    }

    checkAnswer(answer) {
        // ensure we ignore spaces and punctuation in our answers
        let justLettersAnswerArray = answer.toUpperCase().split('');
        let justLettersAnswer = [];
        for (let i = 0; i < justLettersAnswerArray.length; i++) {
            if (this.model.alphabet.indexOf(justLettersAnswerArray[i]) >= 0) {
                justLettersAnswer.push(justLettersAnswerArray[i]);
            }
        }
        justLettersAnswer = justLettersAnswer.join('');

        let justLettersCorrectAnswerArray = this.model.cipherPhrase.toUpperCase().split('');
        let justLettersCorrectAnswer = [];
        for (let i = 0; i < justLettersCorrectAnswerArray.length; i++) {
            if (this.model.alphabet.indexOf(justLettersCorrectAnswerArray[i]) >= 0) {
                justLettersCorrectAnswer.push(justLettersCorrectAnswerArray[i]);
            }
        }
        justLettersCorrectAnswer = justLettersCorrectAnswer.join('');

        if (justLettersAnswer === justLettersCorrectAnswer /*&& this.model.currentTestShift === this.model.cipherShift*/) {
            return true;
        }
        return false;
    }
}